import useMutation from "src/hooks/useMutation";

function useProductCreate() {
  return useMutation({
    path: "/api/v1/products",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/products`,
      shouldRevalidate: true,
    },
  });
}

export default useProductCreate;
